/**
 * @generated SignedSource<<75d8d85e55f620bfaa4cf831ea5ab1d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type JiraAssigneeResourceTagKeysPaginationQuery$variables = {
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  filter?: FilterElementInput | null | undefined;
};
export type JiraAssigneeResourceTagKeysPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JiraAssignee_resourceTagKeys">;
};
export type JiraAssigneeResourceTagKeysPaginationQuery = {
  response: JiraAssigneeResourceTagKeysPaginationQuery$data;
  variables: JiraAssigneeResourceTagKeysPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 100,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "filterElement",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JiraAssigneeResourceTagKeysPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          }
        ],
        "kind": "FragmentSpread",
        "name": "JiraAssignee_resourceTagKeys"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JiraAssigneeResourceTagKeysPaginationQuery",
    "selections": [
      {
        "alias": "jiraAssigneeResourceTagKeys",
        "args": (v1/*: any*/),
        "concreteType": "ResourceTagKeyConnection",
        "kind": "LinkedField",
        "name": "resourceTagKeys",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ResourceTagKeyEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResourceTagKey",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "jiraAssigneeResourceTagKeys",
        "args": (v1/*: any*/),
        "filters": [
          "filterElement"
        ],
        "handle": "connection",
        "key": "JiraAssignee__jiraAssigneeResourceTagKeys",
        "kind": "LinkedHandle",
        "name": "resourceTagKeys"
      }
    ]
  },
  "params": {
    "cacheID": "d6b2ec74e6f6d0d705a06de6f26ae3d8",
    "id": null,
    "metadata": {},
    "name": "JiraAssigneeResourceTagKeysPaginationQuery",
    "operationKind": "query",
    "text": "query JiraAssigneeResourceTagKeysPaginationQuery(\n  $count: Int = 100\n  $cursor: String\n  $filter: FilterElementInput\n) {\n  ...JiraAssignee_resourceTagKeys_3KQYpM\n}\n\nfragment JiraAssignee_resourceTagKeys_3KQYpM on Query {\n  jiraAssigneeResourceTagKeys: resourceTagKeys(first: $count, after: $cursor, filterElement: $filter) {\n    edges {\n      node {\n        key\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "83a1a2b8c75b060a099d59e9605b0c86";

export default node;
